import AssignmentType from "./actionTypes"

// function that called as action
const getStaffTrouserList = data => ({
  type: AssignmentType.GET_ASSIGNMENT_STAFF_TROUSER_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getStaffTrouserListSuccess = data => ({
  type: AssignmentType.GET_ASSIGNMENT_STAFF_TROUSER_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getStaffJacketList = data => ({
  type: AssignmentType.GET_ASSIGNMENT_STAFF_JACKET_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getStaffJacketListSuccess = data => ({
  type: AssignmentType.GET_ASSIGNMENT_STAFF_JACKET_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getRtwOrderList = data => ({
  type: AssignmentType.GET_ASSIGNMENT_RTW_ORDER_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getRtwOrderListSuccess = data => ({
  type: AssignmentType.GET_ASSIGNMENT_RTW_ORDER_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getRtwOrderSizeList = data => ({
  type: AssignmentType.GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getRtwOrderSizeListSuccess = data => ({
  type: AssignmentType.GET_ASSIGNMENT_RTW_ORDER_SIZE_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getOrderList = data => ({
  type: AssignmentType.GET_ASSIGNMENT_ORDER_LIST,
  payload: data,
})

// function to update state in reducer when fetching api is succeed or failed
const getOrderListSuccess = data => ({
  type: AssignmentType.GET_ASSIGNMENT_ORDER_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const getWeekList = (data, action) => ({
  type: AssignmentType.GET_ASSIGNMENT_WEEK_LIST,
  payload: data,
  action,
})

// function to update state in reducer when fetching api is succeed or failed
const getWeekListSuccess = data => ({
  type: AssignmentType.GET_ASSIGNMENT_WEEK_LIST_SUCCESS,
  payload: data,
})

// function that called as action
const putRtwOrder = (data, action) => {
  return {
    type: AssignmentType.PUT_ASSIGNMENT_RTW_ORDER,
    payload: data,
    action,
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putRtwOrderSuccess = data => ({
  type: AssignmentType.PUT_ASSIGNMENT_RTW_ORDER_SUCCESS,
  payload: data,
})

// function that called as action
const putOrder = (data, action) => {
  return {
    type: AssignmentType.PUT_ASSIGNMENT_ORDER,
    payload: data,
    action,
  }
}

// function to update state in reducer when fetching api is succeed or failed
const putOrderSuccess = data => ({
  type: AssignmentType.PUT_ASSIGNMENT_ORDER_SUCCESS,
  payload: data,
})

// function that called as action
const deleteRtwOrder = (data, action) => {
  return {
    type: AssignmentType.DELETE_ASSIGNMENT_RTW_ORDER,
    payload: data,
    action,
  }
}

// function to update state in reducer when fetching api is succeed or failed
const deleteRtwOrderSuccess = data => ({
  type: AssignmentType.DELETE_ASSIGNMENT_RTW_ORDER_SUCCESS,
  payload: data,
})

// function that called as action
const deleteOrder = (data, action) => {
  return {
    type: AssignmentType.DELETE_ASSIGNMENT_ORDER,
    payload: data,
    action,
  }
}

// function to update state in reducer when fetching api is succeed or failed
const deleteOrderSuccess = data => ({
  type: AssignmentType.DELETE_ASSIGNMENT_ORDER_SUCCESS,
  payload: data,
})

// function that called as action
const patchData = (data, action) => {
  return {
    type: AssignmentType.PATCH_ASSIGNMENT_DATA,
    payload: data,
    action,
  }
}

// function to update state in reducer when fetching api is succeed or failed
const patchDataSuccess = data => ({
  type: AssignmentType.PATCH_ASSIGNMENT_DATA_SUCCESS,
  payload: data,
})

const putDataLocal = data => ({
  type: AssignmentType.PUT_ASSIGNMENT_ORDER_LOCAL_STATE,
  payload: data,
})

const putDataLocalSuccess = data => ({
  type: AssignmentType.PUT_ASSIGNMENT_ORDER_LOCAL_STATE_SUCCESS,
  payload: data,
})

const putRTWDataLocal = data => ({
  type: AssignmentType.PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE,
  payload: data,
})

const putRTWDataLocalSuccess = data => ({
  type: AssignmentType.PUT_ASSIGNMENT_RTW_ORDER_LOCAL_STATE_SUCCESS,
  payload: data,
})

const AssignmentAction = {
  getStaffTrouserList,
  getStaffTrouserListSuccess,
  getStaffJacketList,
  getStaffJacketListSuccess,
  getRtwOrderList,
  getRtwOrderListSuccess,
  getRtwOrderSizeList,
  getRtwOrderSizeListSuccess,
  getOrderList,
  getOrderListSuccess,
  getWeekList,
  getWeekListSuccess,
  putRtwOrder,
  putRtwOrderSuccess,
  putOrder,
  putOrderSuccess,
  deleteRtwOrder,
  deleteRtwOrderSuccess,
  deleteOrder,
  deleteOrderSuccess,
  patchData,
  patchDataSuccess,
  putDataLocal,
  putDataLocalSuccess,
  putRTWDataLocal,
  putRTWDataLocalSuccess,
}

export default AssignmentAction
